import React from "react";
import "./style.scss";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Link } from "react-router-dom";
// import { ReactComponent as WaveSvg } from "../../assets/images/wave-vector-registration.svg";

function RegistrationOfVendor() {
   return (
      <div>
         <nav className="navbar navbar-ngo">
            <div className="container">
               <div className="logo-ingo">
                  <img
                     src={toAbsoluteUrl("/media/logos/kapOrg-logo.svg")}
                     width="100"
                     height="36"
                     className="d-inline-block d-sm-flex justify-content-sm-center align-items-sm-center"
                     alt="NGO Logo"
                  />
               </div>
               <div className="col-12 col-md-9">
                  <h2 className="ingo-navbartext">
                     INGO /&nbsp;
                     <span className="text-white"> Vendor</span>
                  </h2>
               </div>
            </div>
         </nav>

         <div className="bg-white py-5">
            <div className="container d-flex justify-content-around ">
               <div className="mt-5 col-12 col-md-6">
                  <h4 className="sign-up-info">Sign Up Information</h4>

                  <p className="signup-p">
                     To create your account, please fill in the following information.
                  </p>
               </div>
            </div>
         </div>

         <div className="bg-form">
            <div className="container">
               <div className="row justify-content-center">
                  <div className="col-12 col-md-6 mt-10">
                     <div className="mt-5">
                        <h5 className="ingo-login__cred">Login Credentials</h5>
                     </div>
                     <div className="p-8 bg-white mt-15 form-styleNGO">
                        <form>
                           <div className="form-group">
                              <label htmlFor="email">Organization’s Email*</label>
                              <input type="email" className="form-control" />
                           </div>

                           <div className="form-group">
                              <label htmlFor="password">Password*</label>
                              <input type="password" className="form-control" />
                           </div>

                           <div className="form-group">
                              <label htmlFor="confirmPassword">Confirm Password*</label>
                              <input type="password" className="form-control" />
                           </div>
                           <div className="form-group">
                              <label htmlFor="email">Invitation code*</label>
                              <input type="text" className="form-control" />
                           </div>
                        </form>
                     </div>
                  </div>
               </div>

               <div className="container">
                  <div className="row justify-content-center">
                     <div className="col-12 col-md-6 my-12 ">
                        <div className="d-flex justify-content-between">
                           <label className="checkbox">
                              <input
                                 type="checkbox"
                                 name="acceptTerms"
                                 required
                                 className="m-1 terms-conditions-btn"
                              />
                              <span className="mr-3 checkbox__style" />
                              <Link
                                 to="/terms"
                                 target="_blank"
                                 className="mr-1 r-btn ingo-terms-text"
                                 rel="noopener noreferrer"
                              >
                                 I have read and agreed with the{" "}
                                 <span> terms and conditions. </span>
                              </Link>
                           </label>
                        </div>
                     </div>
                  </div>

                  <div className="container">
                     <div className="row justify-content-center">
                        <div className="col-12 col-md-6">
                           <button type="submit" className="btn ngoBtn">
                              <p className="ngoBtn-submit">Submit</p>
                           </button>
                        </div>
                     </div>
                  </div>

                  {/* <div className="footer">
                     <WaveSvg className="wave-svgngo" />
                  </div> */}
               </div>
            </div>
         </div>
      </div>
   );
}
export default RegistrationOfVendor;
